import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "my-profile-inner" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "section-title two" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "Post New Job Ad", -1)
const _hoisted_9 = { class: "profile-form" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Job Information:")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-inner mb-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "job_title" }, "Job Ad Title*", -1)
const _hoisted_15 = { class: "input-area" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-inner mb-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Select Job*", -1)
const _hoisted_21 = { class: "input-area" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "form-inner mb-25" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Job Description*", -1)
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "form-inner" }
const _hoisted_28 = {
  key: 2,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.advertisement), 1)
              ]),
              _createElementVNode("form", _hoisted_9, [
                _hoisted_10,
                (_ctx.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adForm.title) = $event)),
                              type: "text",
                              id: "job_title",
                              name: "job_title",
                              disabled: _ctx.advertisement.id
                            }, null, 8, _hoisted_17), [
                              [_vModelText, _ctx.adForm.title]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_component_Dropdown, {
                              disabled: _ctx.advertisement.id,
                              onChange: _ctx.changeJob,
                              modelValue: this.adForm.job_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.adForm.job_id) = $event)),
                              options: _ctx.companyJobs.Listing,
                              placeholder: "Select Job Type",
                              ref: "language",
                              optionLabel: "job_title",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["disabled", "onChange", "modelValue", "options"])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "job_types"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adForm.description) = $event)),
                            id: "description",
                            placeholder: "Job Description"
                          }, null, 512), [
                            [_vModelText, _ctx.adForm.description]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          (!_ctx.isLoading && _ctx.advertisement.id == null)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createJobAd && _ctx.createJobAd(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, "Post New Job Ad"))
                            : _createCommentVNode("", true),
                          (!_ctx.isLoading && _ctx.advertisement.id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateJobAd && _ctx.updateJobAd(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, "Update Ad Detaile"))
                            : _createCommentVNode("", true),
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_28, _hoisted_31))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}